import React, { FC, useEffect, useState } from 'react';
import styles from './SearchFilter.module.scss';
import { CloseRoundSmall, Dropdown, Input, Magnifier } from 'esa-ui-library';
import { PropertyType, debounce, clearDebounce, useUpdateEffect } from '../../../../../common';
import useFilters from '../../../../../common/hooks/useFilters';

interface SearchFilterProps {
	searchTypes: PropertyType[];
	preselected?: string;
}

const SearchFilter: FC<SearchFilterProps> = ({ searchTypes, preselected }): JSX.Element => {
	const [searchType, setSearchType] = useState<PropertyType>(searchTypes[0]);
	const [searchValue, setSearchValue] = useState(preselected || '');
	const { onFilter } = useFilters();

	const onSearch = () => {
		onFilter([{ name: 'q', value: searchValue }]);
	};

	const onSearchTypeChange = () => {
		onFilter([{ name: 'searchType', value: searchType.value }]);
	};

	const onValueClear = () => {
		setSearchValue('');
	};

	useEffect(() => {
		const deb = debounce(() => onSearch());
		return () => clearDebounce(deb);
	}, [searchValue]);

	useUpdateEffect(() => {
		onSearchTypeChange();
	}, [searchType]);

	return (
		<section className={styles.SearchFilter}>
			<Dropdown
				label={searchType.label}
				options={searchTypes}
				small
				noMargin
				className={styles.Dropdown}
				onChange={(val) => setSearchType(val)}
				dataId='search-type'
			/>
			<section className={styles.Search}>
				<Input
					value={searchValue}
					placeholder='Search'
					small
					noMargin
					icon={<Magnifier />}
					inputClassName={styles.SearchInput}
					onChange={setSearchValue}
				/>
				{searchValue && <CloseRoundSmall className={styles.Clear} onClick={onValueClear} />}
			</section>
		</section>
	);
};

export { SearchFilter };
